import * as React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Badge from "@material-ui/core/Badge";
import AdminIcon from "@material-ui/icons/Person";
import Modal from "@material-ui/core/Modal";
import ArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import MeetingRoomOutlinedIcon from "@material-ui/icons/MeetingRoomOutlined";
import DashboardIcon from "@material-ui/icons/Dashboard";
import Drawer from "@material-ui/core/Drawer/Drawer";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import SettingsIcon from "@material-ui/icons/SettingsOutlined";
import Typography from "@material-ui/core/Typography/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import HelpWidget from "../../../../components/HelpWidget";
import PropTypes from "prop-types";
import BlackDiamondLogo from "../../../../assets/black-diamond-logo-white.png";
import IconButton from "@material-ui/core/IconButton";
import { appAction, userAction } from "../../../../actions";
import GenericHelpModal from "../../../../components/HelpWidget/components/GenericHelpModal";
import { isBasicView, isPremiumView } from "../../../../utilities/access";

const styles = (theme) => ({
  drawerPaper: {
    position: "fixed",
    left: 0,
    top: 0,
    height: "100%",
    whiteSpace: "nowrap",
    width: theme.wbiComponent.floatingNavigation.totalWidth,
    [theme.breakpoints.down("lg")]: {
      width: "150px",
    },
    boxShadow: "0 0 10px rgba(0,0,0,0.6)",
    border: "none",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    "@media print": {
      display: "none",
    },
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.wbiComponent.floatingNavigation.controlWidth,
  },
  navWrapper: {
    width: `calc(100% - ${theme.wbiComponent.floatingNavigation.controlWidth}px)`,
    height: "100%",
    position: "absolute",
    left: 0,
    top: 0,
    background: theme.palette.primary.main,
    boxShadow: "0 0 10px rgba(0,0,0,0.6)",
    zIndex: 10,
    display: "flex",
    flexFlow: "column",
    justifyContent: "space-between",
    "& > *": {
      overflow: "hidden",
      alignSelf: "center",
      width: "100%",
    },
  },
  bottomNav: {
    overflow: "hidden",
  },
  drawerToggle: {
    background: theme.palette.primary.main,
    width: theme.wbiComponent.floatingNavigation.controlWidth,
    position: "absolute",
    right: 0,
    top: 0,
    height: "100%",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  arrowIcon: {
    color: theme.palette.common.white,
    fontSize: 40,
    transition: theme.transitions.create("transform", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    "&.closed": {
      transform: "scaleX(-1)",
    },
  },
  chatWidget: {
    zIndex: 1201,
    height: 1,
    width: 1,
    position: "fixed",
    left: 120,
    top: undefined,
    bottom: 140,
  },
  paper: {
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "hidden",
  },
  listItem: {
    color: theme.palette.common.white,
    display: "block",
    fontSize: 36,
    justifyContent: "center",
    padding: '20px 0',
    cursor: "pointer",
    textAlign: "center",
    "&.mainIcon svg": {
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    "&.flex": {
      display: "flex",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: 25,
      padding: 7,
    },
  },
  userSettingMenu: {
    color: theme.palette.common.white,
    justifyContent: "center",
  },

  mainLogo: {
    maxWidth: 100,
    width: "100%",
    [theme.breakpoints.down("md")]: {
      backgroundSize: "89% !important",
    },
  },
  mainLogoNote: {
    fontSize: 11,
    width: '100%',
    textAlign: 'center',
    color: theme.palette.common.white
  }
});

class FloatingNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openChatFeed: true,
      firstOpen: true,
    };
  }
  toggleDrawer = () => {
    this.props.dispatch(appAction.toggleMainNav(!this.props.mainNavOpened));
  };

  toggleHelpWidget = (e, shouldClose) => {
    if (shouldClose) {
      this.props.dispatch(
        appAction.toggleHelpWidget(!this.props.app.helpWidgetOpened)
      );
      this.setState({ firstOpen: true });
    } else if (this.state.firstOpen) {
      this.props.dispatch(
        appAction.toggleHelpWidget(!this.props.app.helpWidgetOpened)
      );
      this.setState({ firstOpen: false });
    }
    this.setState({ openChatFeed: !this.state.openChatFeed });
  };

  logout = () => {
    const { history } = this.props;
    this.props.dispatch(userAction.logout(history));
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { history } = this.props;
    if (!nextProps.user.loggedIn) {
      history.push("/");
    }
  }

  render() {
    const { openChatFeed } = this.state;
    const { classes, mainNavOpened, user, accessLevel, theme, app } = this.props;
    const { helpWidgetOpened = false, useHelpWidget } = app;
    var allowRedirect =
      !app.useVideoGate ||
      (user.user.hasOwnProperty("video_watched") && user.user.video_watched);

    const fullScreen = window.screen.width <= 960;

    return (
      <React.Fragment>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(
              classes.drawerPaper,
              !mainNavOpened && classes.drawerPaperClose
            ),
          }}
          open={mainNavOpened}
        >
          <div className={classes.navWrapper}>
            <List className={classes.topNav} component="nav">
              <Link to={allowRedirect ? "/Portal/dashboard" : "#"}>
                <ListItem button className={`${classes.listItem} mainIcon`}>
                  <DashboardIcon fontSize="inherit" />{" "}
                  <Typography
                    variant="body1"
                    style={{ color: theme.palette.common.white }}
                  >
                    Dashboard
                  </Typography>
                </ListItem>
              </Link>
              <Link to={allowRedirect ? "/Portal/education" : "#"}>
                <ListItem button className={`${classes.listItem} mainIcon`}>
                  <LibraryBooksIcon fontSize="inherit" />{" "}
                  <Typography
                    variant="body1"
                    style={{ color: theme.palette.common.white }}
                  >
                    Education
                  </Typography>
                </ListItem>
              </Link>
              {isPremiumView(accessLevel) && (
                <a
                  href="https://login.bdreporting.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ListItem button className={`${classes.listItem} mainIcon`}>
                    <img
                      src={BlackDiamondLogo}
                      alt="Black Diamond Reporting"
                      height={36}
                    />
                    <Typography
                      variant="body1"
                      style={{ color: theme.palette.common.white }}
                    >
                      Black Diamond
                      <br />
                      Reporting
                    </Typography>
                  </ListItem>
                </a>
              )}

              {!isBasicView(accessLevel) && user.user.isAdmin && (
                <Link to={"/Portal/admin"}>
                  <ListItem button className={`${classes.listItem} mainIcon`}>
                    <AdminIcon fontSize="inherit" />
                    <Typography
                      variant="body1"
                      style={{ color: theme.palette.common.white }}
                    >
                      Admin
                    </Typography>
                  </ListItem>
                </Link>
              )}

              {
                // user.user.approved
                // &&
                // <ListItem className={`${classes.listItem} mainIcon`} >
                //   {
                //     user.user.hasOwnProperty('video_watched') && user.user.video_watched ?
                //     <Link to={'/Portal/paperwork'}><AttachFileIcon fontSize="inherit"/> <Typography variant='body1' style={{color: theme.palette.common.white}}>Documents</Typography></Link> :
                //     <Link to={'#'}><AttachFileIcon fontSize="inherit"/> <Typography variant='body1' style={{color: theme.palette.common.white}}>Documents</Typography></Link>
                //   }
                // </ListItem>
              }
            </List>
            <List className={classes.bottomNav}>
              <ListItem className={classes.userSettingMenu}>
                <Tooltip title="Log Out" placement="top">
                  <IconButton
                    aria-label="logout"
                    size="small"
                    style={{ color: theme.palette.common.white }}
                    onClick={this.logout}
                  >
                    <MeetingRoomOutlinedIcon
                      fontSize="default"
                    />
                  </IconButton>
                </Tooltip>
                {/* useVideogate should not be checked at button level, but introduce it at navigation level, mmkay !! */}
                <Link style={{ display: "flex" }} to="/Portal/user/profile">
                  <Tooltip title="Settings" placement="top">
                    <IconButton
                      aria-label="settings"
                      size="small"
                      style={{ color: theme.palette.common.white }}
                    >
                      <SettingsIcon fontSize="default" />
                    </IconButton>
                  </Tooltip>
                </Link>
                {
                  useHelpWidget &&
                  useHelpWidget === 'scripted' &&
                  <div>
                    <Tooltip title="Help" placement="top">
                      <IconButton
                        aria-label="help-icon"
                        size="small"
                        style={{ color: theme.palette.common.white }}
                        onClick={(e) =>
                          this.toggleHelpWidget(
                            e,
                            this.state.firstOpen ? false : !helpWidgetOpened
                          )
                        }
                      >
                        <Badge
                          color="error"
                          variant="dot"
                          overlap="circle"
                          badgeContent=" "
                          invisible={this.state.firstOpen}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <HelpOutlineIcon
                            fontSize="default"
                            onClick={(e) =>
                              this.toggleHelpWidget(
                                e,
                                this.state.firstOpen ? false : !helpWidgetOpened
                              )
                            }
                            id="help-icon"
                          />
                        </Badge>
                      </IconButton>
                    </Tooltip>
                    <Modal
                      fullScreen={fullScreen}
                      open={helpWidgetOpened}
                      className={classes.chatWidget}
                      hideBackdrop
                      disableScrollLock
                      disableEnforceFocus={true}
                    >
                      <HelpWidget
                        openChatFeed={openChatFeed}
                        handleCloseChat={(e) => this.toggleHelpWidget(e, true)}
                        handleMinimizeChat={(e) =>
                          this.toggleHelpWidget(
                            e,
                            this.state.firstOpen ? false : !helpWidgetOpened
                          )
                        }
                      />
                    </Modal>
                  </div>
                  }
                  {
                    useHelpWidget &&
                    useHelpWidget === 'generic' &&
                    <div>
                      <GenericHelpModal
                        dialogAnchorComponent={
                          <IconButton
                            aria-label="help-icon"
                            size="small"
                            style={{ color: theme.palette.common.white }}
                          >
                            <HelpOutlineIcon
                              fontSize="default"
                              id="help-icon"
                            />
                          </IconButton>
                        }
                      />
                    </div>
                  }
              </ListItem>
              <ListItem>
                { app.logo && <img className={classes.mainLogo} src={app.logo} alt="app logo" /> }
              </ListItem>
              { app.customizedTheme &&
                <ListItem>
                  <Typography className={classes.mainLogoNote} variant={'body1'}>
                    Powered by Cy
                  </Typography>
                </ListItem>
              }
            </List>
          </div>
          <div className={classes.drawerToggle} onClick={this.toggleDrawer}>
            <ArrowLeft
              className={`${classes.arrowIcon} ${
                !mainNavOpened ? "closed" : ""
              }`}
            />
          </div>
        </Drawer>
      </React.Fragment>
    );
  }
}

FloatingNavigation.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  mainNavOpened: PropTypes.bool.isRequired,
  accessLevel: PropTypes.number.isRequired,
  helpWidgetOpened: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    app: state.app,
    user: state.user,
  };
};
export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(FloatingNavigation)
);



// WEBPACK FOOTER //
// ./src/containers/Cy/components/FloatingNavigation/index.jsx